import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class RuleDTO  {
    _originalTypeClassName = "zERP.BO.RuleDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
RuleDTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.RuleDTOKey = null;
this._key = this.RuleDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Name:any;
private _RuleDTOKey:any;
get RuleDTOKey(): any {
    return this._RuleDTOKey;
  }
set RuleDTOKey(value: any) {
    this._RuleDTOKey = value;
    this._key = value;
  }

static AssignContribution(cr: any): any{let r = new Domain.RuleDTO();
r.Id = cr?.Id;
r.Name = cr?.Name;
return r;
}
static AssignDeduction(sdr: any): any{let rDTO = new Domain.RuleDTO();
rDTO.Id = sdr?.Id;
rDTO.Name = sdr?.Name;
return rDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.RuleDTOKey == null || $this.RuleDTOKey == 0;
            }


}